import React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { Menu } from 'antd'
import { TabConfig } from '../../types'

import styles from './index.module.less'

interface TabsMenuProps {
	tabs: TabConfig[]
}

export default function TabsMenu({ tabs }: TabsMenuProps) {
	const history = useHistory()
	const match = useRouteMatch<{ tab: string }>()

	const goToTab = (key: string): void => {
		const splitPath = match.path.split('/')
		const splitUrl = match.url.split('/')
		splitUrl[splitPath.indexOf(':tab')] = key
		const newUrl = splitUrl.join('/')
		history.replace(newUrl)
	}

	return (
		<Menu className={styles.menu} onClick={({ key }): void => goToTab(key)} selectedKeys={[match.params.tab]} mode='horizontal'>
			{tabs.map(tab => (
				<Menu.Item key={tab.id}>{tab.title}</Menu.Item>
			))}
		</Menu>
	)
}
